import React from "react";

const MultiSelectDropDown = (props) => {
  const [open, setOpen] = React.useState(false);

  const wrapperRef = React.useRef(null);

  const toggleOpen = () => {
    setOpen((prevOpen) => !prevOpen);  // Use functional update to ensure correct toggle
  };

  const dropDownClicked = (event) => {
    event.stopPropagation();
    toggleOpen();  // Toggle dropdown state
  };

  const dropDownItemClicked = (item) => {
    item.selected = !item.selected;
    props.onItemSelected && props.onItemSelected(item);
  };

  const setWrapperRef = (node) => (wrapperRef.current = node);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  let className = props.cssClass;
  const hasSelectedItems = props.items.filter((item) => item.selected ?? false).length > 0;
  const isDisabled = props.items.length === 0;

  if (hasSelectedItems) {
    className += " c-filter-dropdown__select--checked";
  }
  if (open) {
    className += " c-filter-dropdown__select--open";
  }

  return (
    <div ref={setWrapperRef} className="c-filter-dropdown c-filter-dropdown--multiselect">
      <button className={className} onClick={dropDownClicked} disabled={isDisabled} aria-disabled={isDisabled}>
        {props.title}
        <span className="c-filter-dropdown__count">
          {hasSelectedItems ? props.items.filter((item) => item.selected).length : ""}
        </span>
        <i className="icon-keyboard_arrow_down"></i>
      </button>

      {open && (
        <div className="c-filter-dropdown__list">
          {props.items.map((item) => (
            <div
              key={item.value}
              className={
                item.selected
                  ? "c-filter-dropdown__list-item c-filter-dropdown__list-item--active"
                  : "c-filter-dropdown__list-item"
              }
            >
              <label htmlFor={item.value}>
                {item.text} ({item.count})
                <input
                  type="checkbox"
                  name={item.value}
                  id={item.value}
                  value={item.value}
                  checked={item.selected}
                  onClick={() => dropDownItemClicked(item)}
                  readOnly
                />
                <span className="c-filter-dropdown__checkmark"></span>
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropDown;
